import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { defaultProps } from '../utils/defaultProps';
import { getUidStr } from '../utils/uid';
import { getDirectionClass } from '../utils/classname';
import { isEnterPress, isFunc } from '../utils/is';
import Input from '../Input';
import Spin from '../Spin';
import { checkinputClass } from './styles';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';

function checkItem(type) {
  var CheckItem =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CheckItem, _PureComponent);

    var _super = _createSuper2(CheckItem);

    function CheckItem(props) {
      var _this;

      _classCallCheck(this, CheckItem);

      _this = _super.call(this, props);
      _this.id = void 0;
      _this.input = void 0;
      _this.el = void 0;

      _this.onClick = function (e) {
        e.stopPropagation();
        var onClick = _this.props.onClick;
        if (isFunc(onClick)) onClick(e);
      };

      _this.state = {
        checked: typeof props.checked === 'function' ? undefined : props.checked
      };
      _this.id = "cb_".concat(getUidStr());
      _this.input = null;
      _this.el = null;
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
      _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
      _this.handleEnter = _this.handleEnter.bind(_assertThisInitialized(_this));
      _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(CheckItem, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props = this.props,
            checked = _this$props.checked,
            inputable = _this$props.inputable,
            value = _this$props.value,
            htmlValue = _this$props.htmlValue;

        if (prevProps.value !== value && checked === undefined) {
          // eslint-disable-next-line
          this.setState({
            checked: inputable ? !!value : value === htmlValue
          });
        }
      }
    }, {
      key: "getChecked",
      value: function getChecked() {
        var _this$props2 = this.props,
            checked = _this$props2.checked,
            value = _this$props2.value,
            htmlValue = _this$props2.htmlValue; // 传函数的用法

        if (typeof checked === 'function') return checked(htmlValue);
        if (checked !== undefined) return checked;
        if (this.state.checked === undefined) return value === htmlValue;
        return this.state.checked;
      }
    }, {
      key: "getProp",
      value: function getProp(key) {
        if (this.props[key] !== undefined) return this.props[key];
        return this.state[key];
      }
    }, {
      key: "bindRef",
      value: function bindRef(el) {
        if (el) this.el = el;
      }
    }, {
      key: "handleEnter",
      value: function handleEnter(e) {
        if (isEnterPress(e)) {
          if (type === 'radio' && this.getChecked()) return;
          this.handleChange({
            target: {
              checked: !this.getChecked()
            }
          }); // e.target.click()
          // if (this.el) this.el.focus()
        }
      }
    }, {
      key: "handleChange",
      value: function handleChange(e) {
        var _this2 = this;

        var _this$props3 = this.props,
            onChange = _this$props3.onChange,
            onRawChange = _this$props3.onRawChange,
            index = _this$props3.index,
            inputable = _this$props3.inputable;
        var checked = e.target.checked;
        this.setState({
          checked: checked
        }, function () {
          return _this2.el.focus();
        });

        if (type === 'switch' && onChange) {
          onChange(checked);
          return;
        }

        var value = inputable ? this.props.value : this.props.htmlValue;
        if (onRawChange) onRawChange(value, checked);
        value = checked ? value : undefined;
        if (onChange) onChange(value, checked, index);
      }
    }, {
      key: "handleInputChange",
      value: function handleInputChange(val) {
        var _this$props4 = this.props,
            onChange = _this$props4.onChange,
            index = _this$props4.index;
        var checked = val.length > 0;
        if (onChange) onChange(val, checked, index);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props5 = this.props,
            disabled = _this$props5.disabled,
            style = _this$props5.style,
            content = _this$props5.content,
            size = _this$props5.size,
            children = _this$props5.children,
            inputable = _this$props5.inputable,
            loading = _this$props5.loading;
        var rtl = isRTL();
        var checked = this.getChecked();
        var isSwitch = type === 'switch';
        var ban = disabled || isSwitch && loading;
        var className = classnames(checkinputClass('_', ban && 'disabled', checked === true && 'checked', checked === 'indeterminate' && 'indeterminate', isSwitch && 'switch', loading && 'loading', "".concat(type, "-container"), rtl && 'rtl', {
          large: size === 'large',
          small: size === 'small'
        }), this.props.className);

        var _ref = content || [],
            _ref2 = _slicedToArray(_ref, 2),
            checkedChildren = _ref2[0],
            uncheckedChildren = _ref2[1];

        var switchChildren = isSwitch && size !== 'small' ?
        /*#__PURE__*/
        React.createElement("span", {
          className: checkinputClass('switch-children')
        }, checked ? checkedChildren : uncheckedChildren) : null;
        var value = typeof this.props.value === 'string' ? this.props.value : '';
        return (
          /*#__PURE__*/
          React.createElement("label", Object.assign({
            onKeyDown: this.handleEnter,
            className: className,
            style: style,
            htmlFor: this.id,
            tabIndex: disabled ? undefined : 0,
            ref: this.bindRef
            /* @ts-ignore */
            ,
            disabled: ban
          }, getDataset(this.props)), switchChildren,
          /*#__PURE__*/
          React.createElement("input", {
            id: this.id,
            disabled: ban,
            tabIndex: -1,
            type: isSwitch ? 'checkbox' : type,
            onClick: this.onClick,
            onChange: this.handleChange,
            checked: checked
          }),
          /*#__PURE__*/
          React.createElement("i", {
            className: checkinputClass('indicator', type)
          }), children && !isSwitch &&
          /*#__PURE__*/
          React.createElement("span", {
            className: checkinputClass('desc')
          }, children), inputable && !isSwitch && checked &&
          /*#__PURE__*/
          React.createElement(Input, {
            className: checkinputClass('text'),
            onChange: this.handleInputChange,
            value: value
          }), isSwitch &&
          /*#__PURE__*/
          React.createElement("span", {
            className: checkinputClass(getDirectionClass('switch-indicator'))
          }, loading ?
          /*#__PURE__*/
          React.createElement(Spin, {
            size: "auto",
            color: "none",
            name: "ring"
          }) : null))
        );
      }
    }]);

    return CheckItem;
  }(PureComponent);

  CheckItem.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
    htmlValue: true,
    onClick: undefined,
    content: []
  });
  return CheckItem;
}

export default checkItem;